import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon, ShieldCheckIcon } from 'lucide-react';
interface OfferProps {
  onCta: () => void;
}
const INCLUDES = ['5 módulos completos de Pilates Resuelto', '5 especializaciones profesionales', '52 clases listas para usar', 'Acceso inmediato y de por vida'];
const EXCLUSIVE_BONUSES = ['100 ejercicios express', '30 clases de emergencia', 'Manual de cues y correcciones', 'Evaluaciones y fichas imprimibles', '20 casos reales resueltos'];
export function Offer({
  onCta
}: OfferProps) {
  return <section className="w-full bg-brown-dark py-20 sm:py-24" data-id="element-78" data-mp="13wrelxkiiyt7">
      <div className="mx-auto max-w-3xl px-5 sm:px-6" data-id="element-79" data-mp="13ycb3sqe0rtp">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.55
      }} className="relative overflow-hidden rounded-[2rem] bg-beige p-7 text-center shadow-2xl shadow-black/30 sm:p-10" data-id="element-80" data-mp="yxojb4uc46yf">
          <div className="pointer-events-none absolute -right-5 -top-5 h-28 w-28 text-brown-light/25" aria-hidden="true" data-id="element-81" data-mp="pjpdu8g8tctm">
            <div className="absolute left-[30px] top-[27px] h-10 w-10 rounded-full border-[7px] border-current" data-id="element-82" data-mp="ul4vrrn4j37s" />
            <div className="absolute left-[58px] top-[27px] h-10 w-10 rounded-full border-[7px] border-current" data-id="element-83" data-mp="13k000y6ly38g" />
            <div className="absolute left-[51px] top-[55px] h-12 w-6 -rotate-[18deg] rounded-b-full border-l-[7px] border-current" data-id="element-84" data-mp="6u9896ppau6c" />
            <div className="absolute left-[62px] top-[55px] h-12 w-6 rotate-[18deg] rounded-b-full border-r-[7px] border-current" data-id="element-85" data-mp="btlvhskhi39g" />
          </div>

          <div className="relative" data-id="element-86" data-mp="kl4ai05p2d0y">
            <p className="inline-flex items-center gap-2 rounded-full bg-brown-light px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-beige" data-id="element-87" data-mp="km5w2ykc6hwx">
              <GiftIcon className="h-3.5 w-3.5" data-id="element-88" data-mp="3oa7mf3zfbpod" />
              Oferta por tiempo limitado
            </p>
            <h2 className="mx-auto mt-5 max-w-xl font-serif text-4xl font-semibold leading-[1.05] text-brown-dark sm:text-5xl" data-id="element-89" data-mp="vfqtjs3t4ung">
              Tu forma más simple de enseñar con seguridad
            </h2>
            <p className="mx-auto mt-4 max-w-lg text-base leading-relaxed text-brown-dark/70" data-id="element-90" data-mp="155af55iwn2m0">
              Llevate el sistema completo y todos los recursos extra para resolver tus clases desde el primer día.
            </p>

            <div className="mt-8 grid gap-5 text-left sm:grid-cols-2" data-id="element-91" data-mp="chxu4zse72ut">
              <div className="rounded-2xl border border-brown-light/20 bg-white/70 p-6" data-id="element-92" data-mp="7i1pqzfs99eq">
                <p className="text-xs font-bold uppercase tracking-[0.16em] text-brown-light" data-id="element-93" data-mp="lhkx3q0rsgpz">
                  Tu compra incluye
                </p>
                <ul className="mt-4 space-y-3" data-id="element-94" data-mp="hf6acutzcwtf">
                  {INCLUDES.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-brown-dark/80" data-id="element-95" data-mp="1wvevmt3jn5hy">
                      <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-brown-light" strokeWidth={3} data-id="element-96" data-mp="1suv0tw6g0dyz" />
                      {item}
                    </li>)}
                </ul>
              </div>

              <div className="rounded-2xl border border-brown-light/35 bg-brown-light/10 p-6" data-id="element-97" data-mp="25bdxayev8c8p">
                <div className="flex items-center gap-2" data-id="element-98" data-mp="1qiu871ojw5a9">
                  <GiftIcon className="h-4 w-4 text-brown-light" data-id="element-99" data-mp="1vgc7e0crn652" />
                  <p className="text-xs font-bold uppercase tracking-[0.16em] text-brown-light" data-id="element-100" data-mp="2j5evnr1wnx8j">
                    Además, gratis
                  </p>
                </div>
                <p className="mt-2 font-serif text-xl font-semibold text-brown-dark" data-id="element-101" data-mp="2o62mabm82c28">
                  5 bonos exclusivos
                </p>
                <ul className="mt-4 space-y-2.5" data-id="element-102" data-mp="2edn8zrlvebno">
                  {EXCLUSIVE_BONUSES.map(bonus => <li key={bonus} className="flex items-start gap-2.5 text-sm leading-relaxed text-brown-dark/80" data-id="element-103" data-mp="322y8l5rhi008">
                      <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-brown-light" strokeWidth={3} data-id="element-104" data-mp="36wakcfb2ecbk" />
                      {bonus}
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="my-8 border-t border-brown-light/20" data-id="element-105" data-mp="1988i6kweuj0t" />

            <div className="flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-6" data-id="element-106" data-mp="198gsc515fa8b">
              <div className="sm:text-right" data-id="element-107" data-mp="14ayh27znsix5">
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-brown-dark/45" data-id="element-108" data-mp="21xfbn5h0cif7">Antes</p>
                <p className="text-xl font-medium text-brown-dark/40 line-through" data-id="element-109" data-mp="1wxj8f8g4wv0p">$49.990</p>
              </div>
              <div className="hidden h-10 w-px bg-brown-light/25 sm:block" data-id="element-110" data-mp="1s618mnpul0hb" />
              <div className="sm:text-left" data-id="element-111" data-mp="1n8j73ie5tnjc">
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-brown-light" data-id="element-112" data-mp="1n7gff890jh2d">Hoy</p>
                <p className="font-serif text-6xl font-bold leading-none text-brown-dark" data-id="element-113" data-mp="2koonvmi5xlah">$19.990</p>
              </div>
            </div>

            <button onClick={onCta} className="mt-8 w-full rounded-full bg-brown-dark px-8 py-4 text-sm font-bold uppercase tracking-wide text-beige shadow-lg shadow-brown-dark/15 transition-transform hover:scale-[1.02] active:scale-95" data-id="element-114" data-mp="2o5ksatjqxq3t">
              Quiero mis clases resueltas
            </button>

            <p className="mt-4 flex items-center justify-center gap-2 text-xs text-brown-dark/60" data-id="element-115" data-mp="325virvh592og">
              <ShieldCheckIcon className="h-4 w-4" data-id="element-116" data-mp="373dx61dxka3u" />
              Compra segura · Acceso inmediato · Sin pagos mensuales
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}